import { Link } from "react-router-dom";

/**
 * BV logo variants.
 *
 * mode:
 *   "symbol"    → only the circular BV mark (navbar, mobile)
 *   "full"      → full lockup image (footer, marketing surfaces)
 *
 * variant:
 *   "dark"  → logo on light backgrounds (default colours)
 *   "light" → invert to white (footer / dark surfaces)
 */
export default function Logo({ mode = "full", variant = "dark", className = "" }) {
  const isLight = variant === "light";
  const src = mode === "symbol" ? "/bv-symbol.png" : "/bv-logo-v2.png";
  const altClass = mode === "symbol" ? "bv-logo-symbol-img" : "bv-logo-full-img";

  return (
    <Link
      to="/"
      data-testid={`brand-logo-${mode}`}
      aria-label="BV Business Consulting SRLS — Home"
      className={`inline-flex items-center ${className}`}
    >
      <img
        src={src}
        alt="BV Business Consulting SRLS"
        className={altClass}
        style={isLight ? { filter: "brightness(0) invert(1)" } : undefined}
      />
    </Link>
  );
}
